module.exports = __webpack_public_path__ + "static/logo-075917b96b95ba2622007883f63f7772.png";